import { IFeedback, IFeedbackFetch, IHost, IHostFetch } from 'src/models/IHost';

export enum HostActionEnum {
  REQUEST_HOSTS = 'REQUEST_HOSTS',
  RESULT_HOSTS = 'RESULT_HOSTS',
  ERROR_HOSTS = 'ERROR_HOSTS',

  REQUEST_HOST = 'REQUEST_HOST',
  RESULT_HOST = 'RESULT_HOST',

  REQUEST_ADD_HOST = 'REQUEST_ADD_HOST',
  RESULT_ADD_HOST = 'RESULT_ADD_HOST',

  REQUEST_UPDATE_HOST = 'REQUEST_UPDATE_HOST',
  RESULT_UPDATE_HOST = 'RESULT_UPDATE_HOST',

  REQUEST_DELETE_HOST = 'REQUEST_DELETE_HOST',
  RESULT_DELETE_HOST = 'RESULT_DELETE_HOST',

  REQUEST_DELETE_STRIPE_ID = 'REQUEST_DELETE_STRIPE_ID',
  RESULT_DELETE_STRIPE_ID = 'RESULT_DELETE_STRIPE_ID',

  CLEAR_HOST_RESULT = 'CLEAR_HOST_RESULT',

  REQUEST_ADD_REVIEW = 'REQUEST_ADD_REVIEW',
  RESULT_ADD_REVIEW = 'RESULT_ADD_REVIEW',

  REQUEST_UPDATE_REVIEW = 'REQUEST_UPDATE_REVIEW',
  RESULT_UPDATE_REVIEW = 'RESULT_UPDATE_REVIEW',

  REQUEST_DELETE_REVIEW = 'REQUEST_DELETE_REVIEW',
  RESULT_DELETE_REVIEW = 'RESULT_DELETE_REVIEW',

  REQUEST_ADD_AVATAR = 'REQUEST_ADD_AVATAR',
  RESULT_ADD_AVATAR = 'RESULT_ADD_AVATAR'
}

export interface HostState {
  hostList: IHostFetch[];
  addedHostId?: number;
  total: number | null;
  isLoading: {
    all: boolean;
    get: boolean;
    add: boolean;
    delete: boolean;
    update: boolean;
    deleteStripe: boolean;
    updateReview: boolean;
    addReview: boolean;
    deleteReview: boolean;
    avatar: boolean;
  };
  result: {
    all?: number | string;
    add?: number | string;
    update?: number | string;
    delete?: number | string;
    avatar?: number | string;
    deleteStripe?: number | string;
    updateReview?: number | string;
    addReview?: number | string;
    deleteReview?: number | string;
  };
}

export interface GetHostsAction {
  type: HostActionEnum.REQUEST_HOSTS;
}

export interface ResultGetHostsAction {
  type: HostActionEnum.RESULT_HOSTS;
  data: IHostFetch[];
  status: number;
}

export interface ErrorHostAction {
  type: HostActionEnum.ERROR_HOSTS;
  payload?: any;
}

export interface AddHostAction {
  type: HostActionEnum.REQUEST_ADD_HOST;
  data: IHost;
}
export interface ResultAddHostAction {
  type: HostActionEnum.RESULT_ADD_HOST;
  data: IHostFetch;
  status: number;
}

export interface UpdateHostAction {
  type: HostActionEnum.REQUEST_UPDATE_HOST;
  currentHost: IHostFetch;
  id: string | number;
}
export interface ResultUpdateHostAction {
  type: HostActionEnum.RESULT_UPDATE_HOST;
  status: number;
}

export interface DeleteHostAction {
  type: HostActionEnum.REQUEST_DELETE_HOST;
  id: number;
}
export interface ResultDeleteHostAction {
  type: HostActionEnum.RESULT_DELETE_HOST;
  status: number;
}

export interface DeleteStripeIdAction {
  type: HostActionEnum.REQUEST_DELETE_STRIPE_ID;
  id: number;
}
export interface ResultDeleteStripeIdAction {
  type: HostActionEnum.RESULT_DELETE_STRIPE_ID;
  data: string;
  status: number;
}

export interface ClearHostResultAction {
  type: HostActionEnum.CLEAR_HOST_RESULT;
}

export interface AddReviewAction {
  type: HostActionEnum.REQUEST_ADD_REVIEW;
  data: IFeedback;
}
export interface ResultAddReviewAction {
  type: HostActionEnum.RESULT_ADD_REVIEW;
  status: number;
}

export interface UpdateReviewAction {
  type: HostActionEnum.REQUEST_UPDATE_REVIEW;
  currentReview: IFeedbackFetch;
  id: string | number;
}
export interface ResultUpdateReviewAction {
  type: HostActionEnum.RESULT_UPDATE_REVIEW;
  status: number;
}

export interface DeleteReviewAction {
  type: HostActionEnum.REQUEST_DELETE_REVIEW;
  id: number;
}
export interface ResultDeleteReviewAction {
  type: HostActionEnum.RESULT_DELETE_REVIEW;
  status: number;
}

export interface AddAvatarAction {
  type: HostActionEnum.REQUEST_ADD_AVATAR;
  id: number;
  file: File;
}
export interface ResultAddAvatarAction {
  type: HostActionEnum.RESULT_ADD_AVATAR;
  status: number;
}

export type HostAction =
  | GetHostsAction
  | ResultGetHostsAction
  | ErrorHostAction
  | AddHostAction
  | ResultAddHostAction
  | UpdateHostAction
  | ResultUpdateHostAction
  | DeleteHostAction
  | ResultDeleteHostAction
  | ClearHostResultAction
  | DeleteStripeIdAction
  | ResultDeleteStripeIdAction
  | AddReviewAction
  | ResultAddReviewAction
  | UpdateReviewAction
  | ResultUpdateReviewAction
  | DeleteReviewAction
  | ResultDeleteReviewAction
  | AddAvatarAction
  | ResultAddAvatarAction;
